import { render, staticRenderFns } from "./ot-edit-claim-details.vue?vue&type=template&id=5ac5df02&scoped=true&"
import script from "./ot-edit-claim-details.vue?vue&type=script&lang=ts&"
export * from "./ot-edit-claim-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-edit-claim-details.vue?vue&type=style&index=0&id=5ac5df02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac5df02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
